/* NIGHT OPERATORS SHOP ALL PAGE, round 1 (lane SHOP-ALL-1022, 22 Oct 2026). NEW FILE.
   Loaded (defer) by the three Shop All sections; runs once.
   1. Chip bar: fixed under the sticky header once it reaches the top; lights the chip of the group in view.
   2. Preview videos: muted loops that load and play only while on screen, at most 4 at once, never under reduced motion.
   3. Add to cart: one line to /cart/add.js, then the theme cart drawer (window.noCartDrawerOpen); never the cart page.
   4. Shop the look: dots stored as picture fractions, mapped through object-fit cover; on desktop a green line runs
      from each card edge to its dot. Recomputed on load, picture load and resize.
   No em or en dashes. */
(function () {
  if (window.__nsaInit) return;
  window.__nsaInit = true;
  var mqPhone = window.matchMedia('(max-width: 989px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* 1. chip bar */
  function headerBottom() {
    var h = document.querySelector('sticky-header') || document.querySelector('.section-header');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 && r.top < 10 ? Math.round(r.bottom) : 0;
  }
  function initBar() {
    var slot = document.querySelector('[data-nsa-slot]');
    var bar = document.querySelector('[data-nsa-bar]');
    if (!slot || !bar) return;
    var list = bar.querySelector('.nsa-bar__list');
    var chips = Array.prototype.slice.call(bar.querySelectorAll('[data-nsa-chip]'));
    var have = {};
    chips.forEach(function (c) { have[c.getAttribute('data-nsa-chip')] = c; });
    var groups = Array.prototype.slice.call(document.querySelectorAll('[data-nsa-group][id]'));
    var lastOn = null, ticking = false;
    function update() {
      ticking = false;
      var top = headerBottom();
      slot.style.minHeight = bar.offsetHeight + 'px';
      var fixed = slot.getBoundingClientRect().top <= top;
      bar.classList.toggle('is-fixed', fixed);
      bar.style.setProperty('--nsa-top', top + 'px');
      var line = Math.max(top + bar.offsetHeight + 80, 150), cur = null;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].getBoundingClientRect().top <= line) { if (have[groups[i].id]) cur = groups[i].id; }
        else break;
      }
      if (!fixed) cur = null;
      if (cur !== lastOn) {
        chips.forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-nsa-chip') === cur); });
        if (cur && have[cur] && list) {
          var c = have[cur];
          var want = c.offsetLeft - 16;
          if (want < list.scrollLeft || c.offsetLeft + c.offsetWidth > list.scrollLeft + list.clientWidth) {
            try { list.scrollTo({ left: Math.max(0, want), behavior: reduce.matches ? 'auto' : 'smooth' }); } catch (e) { list.scrollLeft = want; }
          }
        }
        lastOn = cur;
      }
    }
    function ask() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    update();
  }

  /* 2. preview videos */
  function initVideos() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-nsa-src]'));
    if (!vids.length || reduce.matches || !('IntersectionObserver' in window)) return;
    var playing = [];
    function stop(v) { try { v.pause(); } catch (e) { /* ignore */ } var i = playing.indexOf(v); if (i >= 0) playing.splice(i, 1); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && en.intersectionRatio >= 0.35) {
          if (!v.getAttribute('src')) { v.setAttribute('src', v.getAttribute('data-nsa-src')); }
          var p = v.play();
          if (p && p.catch) p.catch(function () { /* autoplay refused: the poster stays */ });
          if (playing.indexOf(v) < 0) playing.push(v);
          while (playing.length > 4) stop(playing[0]);
        } else {
          stop(v);
        }
      });
    }, { threshold: [0, 0.35] });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* 3. add to cart, then the drawer */
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function initAdd() {
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-nsa-add]');
      if (!b) return;
      ev.preventDefault();
      if (b.disabled) return;
      var label = b.textContent;
      b.disabled = true; b.textContent = 'Adding';
      fetch(root() + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-nsa-add')), quantity: 1 }] })
      }).then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      }).then(function (res) {
        if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Not added');
        b.textContent = 'Added'; b.classList.add('is-done');
        if (typeof window.noCartDrawerOpen === 'function') window.noCartDrawerOpen(res.body);
        setTimeout(function () { b.disabled = false; b.textContent = label; b.classList.remove('is-done'); }, 2200);
      }).catch(function (e) {
        b.textContent = 'Not added';
        b.title = String(e && e.message || '');
        setTimeout(function () { b.disabled = false; b.textContent = label; }, 2600);
      });
    });
  }

  /* 4. shop the look */
  var NS = 'http://www.w3.org/2000/svg';
  function layoutLook(sec) {
    var stage = sec.querySelector('[data-nsa-stage]');
    var img = sec.querySelector('[data-nsa-look-img]');
    var svg = sec.querySelector('[data-nsa-lines]');
    if (!stage || !img) return;
    var nw = img.naturalWidth || Number(img.getAttribute('width')) || 1;
    var nh = img.naturalHeight || Number(img.getAttribute('height')) || 1;
    var fx = (Number(img.getAttribute('data-fx')) || 50) / 100;
    var sr = stage.getBoundingClientRect(), ir = img.getBoundingClientRect();
    var sc = Math.max(ir.width / nw, ir.height / nh);
    var dw = nw * sc, dh = nh * sc;
    var ox = ir.left - sr.left + (ir.width - dw) * fx, oy = ir.top - sr.top + (ir.height - dh) * 0.5;
    var pos = {};
    sec.querySelectorAll('[data-nsa-dot]').forEach(function (d) {
      var x = ox + parseFloat(d.getAttribute('data-x')) * dw, y = oy + parseFloat(d.getAttribute('data-y')) * dh;
      var inside = x >= ir.left - sr.left + 6 && x <= ir.right - sr.left - 6 && y >= ir.top - sr.top + 6 && y <= ir.bottom - sr.top - 6;
      d.style.left = x + 'px'; d.style.top = y + 'px';
      d.classList.toggle('is-on', inside);
      pos[d.getAttribute('data-nsa-dot')] = { x: x, y: y, on: inside };
    });
    if (!svg) return;
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    if (mqPhone.matches) return;
    svg.setAttribute('viewBox', '0 0 ' + sr.width + ' ' + sr.height);
    sec.querySelectorAll('[data-nsa-lc]').forEach(function (c) {
      var p = pos[c.getAttribute('data-nsa-lc')];
      if (!p || !p.on) return;
      var cr = c.getBoundingClientRect();
      var nm = c.querySelector('.nsa-lc__name');
      var ny = nm ? nm.getBoundingClientRect() : cr;
      var x1 = (c.getAttribute('data-side') === 'left' ? cr.right : cr.left) - sr.left;
      var y1 = ny.top + ny.height / 2 - sr.top;
      var ln = document.createElementNS(NS, 'line');
      ln.setAttribute('x1', x1.toFixed(1)); ln.setAttribute('y1', y1.toFixed(1));
      ln.setAttribute('x2', p.x.toFixed(1)); ln.setAttribute('y2', p.y.toFixed(1));
      ln.setAttribute('data-for', c.getAttribute('data-nsa-lc'));
      svg.appendChild(ln);
    });
  }
  function initLooks() {
    var secs = Array.prototype.slice.call(document.querySelectorAll('[data-nsa-look]'));
    if (!secs.length) return;
    function all() { secs.forEach(layoutLook); }
    secs.forEach(function (s) {
      var img = s.querySelector('[data-nsa-look-img]');
      if (img && !img.complete) img.addEventListener('load', function () { layoutLook(s); });
      if ('ResizeObserver' in window) new ResizeObserver(function () { layoutLook(s); }).observe(s);
    });
    window.addEventListener('resize', all);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);
    window.__nsaLayoutLooks = all;
    all();
  }

  function go() { initBar(); initVideos(); initAdd(); initLooks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
